import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Divider, Stack, Box} from '@mui/material';

const Title = (props) => {
  return (
    <Box sx={{wordWrap: 'break-word', my: 'auto'}}>
      <Stack direction='row' spacing={1}>
        {props.logo}
        <Typography
          variant={props.variant || 'h5'}
          sx={props.sx || {textTransform: 'uppercase', margin: '16px', fontWeight: 'bold'}}
          align='left'
        >
          {props.children}
        </Typography>
      </Stack>
      {props.disableDivider ? null : <Divider variant={props.dividerVariant || 'middle'}/>}
    </Box>
  );
};
Title.propTypes = {
  children: PropTypes.node,
  disableDivider: PropTypes.bool,
  dividerVariant: PropTypes.string,
  variant: PropTypes.string,
  sx: PropTypes.object,
  logo: PropTypes.node,
};

export default React.memo(Title);
